import { Collection } from "@type-r/models";
import { asTimelessDate, Column, Columns, Flex, span } from "lqx-react";
import React from "react";
import { InvoiceChange } from "../../api/invoiceChange";
import { AssetTileField, AssetTileHeaderField, AssetTileStatusField, CheckboxColumn, EventsColumn, FirstColumn, SecondColumn, TileContainer, useAssetTileClasses } from "../../components/asset-section-styles";
import { DigiCheckbox, DigiTooltip, limitText } from "../../shared";
import { InblockedAssetsEventStatus } from "../inblocked-assets-event-status";
import { InvoiceExternalSystems } from "./externalSystems";

export const InvoiceTile = ($active, selected: Collection<InvoiceChange>, selectAllAssets) => (({ data, index, style }) => {
    const invoiceChange: InvoiceChange = data.items[index];
    const classes = useAssetTileClasses({ isSelected: $active.value && $active.value.id === invoiceChange.id });
    const $checked = selected ? selected.$includes(invoiceChange) : null;
    const applyNumbersFormat = (num) => parseFloat(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

    const onInvoiceClicked = invoiceChange => $active.set(invoiceChange);

    return (<>
        <div key={invoiceChange.id} style={style} className={classes.root} onClick={() => onInvoiceClicked(invoiceChange)}>
            <TileContainer>
                {selectAllAssets.value &&
                    <CheckboxColumn>
                        <DigiCheckbox checked={true} disabled={true} />
                    </CheckboxColumn>
                }
                {$checked && !selectAllAssets.value &&
                    <CheckboxColumn>
                        <DigiCheckbox $checked={$checked} disabled={selectAllAssets.value} />
                    </CheckboxColumn>
                }
                <Column>
                    <Flex row>
                        <Columns>
                            <EventsColumn>
                                <Flex row>
                                    <InblockedAssetsEventStatus assetChange={invoiceChange} externalSystems={InvoiceExternalSystems} />
                                </Flex>
                                <Flex row>
                                    {/* <>DummyCell</> */}
                                </Flex>
                            </EventsColumn>
                            <FirstColumn>
                                <Flex row>
                                    <DigiTooltip title={invoiceChange.number}>
                                        <AssetTileStatusField> {limitText(invoiceChange.number, 20)}</AssetTileStatusField>
                                    </DigiTooltip>
                                </Flex>
                                <Flex row>
                                    <AssetTileField>Invoice Date {asTimelessDate(invoiceChange.invoiceDate)}</AssetTileField>
                                </Flex>
                            </FirstColumn>
                            <SecondColumn>
                                <Flex row>
                                    <DigiTooltip title={`${invoiceChange.supplier.name} - ${invoiceChange.buyer.name}`}>
                                        <AssetTileHeaderField >{limitText(invoiceChange.supplier.name, 35)} {invoiceChange.supplier.name && '-'} {limitText(invoiceChange.buyer.name, 35)}</AssetTileHeaderField>
                                    </DigiTooltip>
                                </Flex>
                                <Flex row>
                                    <AssetTileField>Face Value {applyNumbersFormat(invoiceChange.faceValue)} </AssetTileField>
                                </Flex>
                            </SecondColumn>
                            <Flex row>
                                {invoiceChange.isArchived ? <ModifyLabel>Archived</ModifyLabel> : <></>}
                            </Flex>
                        </Columns>
                    </Flex>
                </Column>
            </TileContainer>
        </div >
    </>
    )
})

export const ModifyLabel = span({
    marginLeft: '5px',
    color: '#f27324',
    fontSize: '12px',
    fontStyle: 'normal',
    lineHeight: '16px',
    marginTop: '4px'
});